import {pack} from './pack'
import {unpack} from './unpack'
import type {CorePlugin, SingleComponentPlugin} from '../../types'
import {createPluginFromSingleComponentPlugin} from '../../pluginsFactory'

const beautifierSingleComponentPlugin = {
    name: 'BeautifierPlugin',
    pack,
    unpack
} satisfies SingleComponentPlugin

export const beautifierPlugin: CorePlugin = createPluginFromSingleComponentPlugin(beautifierSingleComponentPlugin)
